module.exports = __webpack_public_path__ + "media/images/announceGroup__bg-a4e05bfd50d5f9ceeca341ac48ec55a3.jpg";